import getFullYear from '../../../../Helper/Date/DateFormatter'

const layoutTranslations = {
  'en-US': {
    header: {
      home: 'HOME',
      products: 'SOLUTIONS',
      tradingStrategies: 'TRADE STRATEGIES',
      trading: 'COPY TRADING',
      media: 'DATA E-COMMERCE',
      mining: 'CRYPTO PORTAL',
      technology: 'SERVICES',
      socialNewsApi: 'TRADER NEWS API',
      about: 'ABOUT',
      blog: 'BLOG',
      contact: 'CONTACT',
    },
    footer: {
      copyright: `Copyrights © AI TRADE, INC  2019-${getFullYear}`,
      policy: 'Privacy Policy',
      terms: 'Terms of Use',
    },
  },
}

export default layoutTranslations
